import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "Search"
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "29", "height": "25", "fill": "currentColor", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "m21.4 19.6-4.9-4.9a8.02 8.02 0 0 0 1.55-4.7c0-4.4-3.6-8-8-8S2 5.6 2 10s3.6 8 8 8c1.75 0 3.4-.55 4.7-1.55l4.9 4.9c.5.5 1.3.5 1.75 0 .5-.45.5-1.25.05-1.75ZM3.5 10c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5-6.5-2.9-6.5-6.5Z" } }), _c("path", { attrs: { "d": "M28.104 11.356h-3.97V7.387h-1.26v3.969h-3.968v1.26h3.969v3.969h1.26v-3.969h3.969v-1.26Z" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const zoomIcon = __component__.exports;
export {
  zoomIcon as default
};
